<template>
  <div class="relative">
    <input
      :id="inputId"
      class="w-full h-[42px] p-2.5 pr-[40px] font-normal text-[14px] border text-primary-dark bg-white border-grey-light rounded-md focus:outline-none focus:border-[#1F1D1F] placeholder:!text-[#B7B2B5]"
      :placeholder="placeholder"
      :value="modelValue"
      @input="updateValue($event.target.value)"
      @keydown.enter="search()"
    />
    <SearchIcon
      v-if="modelValue == ''"
      class="absolute text-primary-dark -translate-y-1/2 right-4 top-1/2"
    />
    <!-- for clear -->
    <svg
      v-if="modelValue"
      @click="emit('update:modelValue', '')"
      class="absolute text-primary-dark -translate-y-1/2 right-4 top-1/2 cursor-pointer"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M6 6l8 8M14 6l-8 8"
        stroke="#555055"
        stroke-width="1.8"
        stroke-linecap="round"
      />
    </svg>
    <!-- for clear -->
  </div>
</template>
<script setup>
const props = defineProps({
  inputId: {
    type: String,
    default: "searchInput",
  },
  placeholder: { type: String, default: "ค้นหา ชื่อทีมแพทย์, ชื่อหัวหน้าทีม" },
  modelValue: {
    type: [String, Number],
    default: "",
  },
});

const emit = defineEmits(["update:modelValue", "search"]);

const updateValue = (value) => {
  emit("update:modelValue", value);
};
</script>

<style lang="scss">
</style>